// Org signup intent captured from the ?intent= param the login flow appends.
// Stashed in sessionStorage so it rides the very first /v1/me request as a
// header, letting the backend gate org signups onto the waitlist before the
// session resolver can auto-approve them as single users.
const KEY = "condense.signup_intent";

export function captureSignupIntent(): void {
  try {
    const v = new URLSearchParams(window.location.search).get("intent");
    if (v === "org" || v === "single") sessionStorage.setItem(KEY, v);
  } catch {
    /* sessionStorage blocked (private mode) — header is just omitted */
  }
}

export function signupIntentHeader(): Record<string, string> {
  try {
    const v = sessionStorage.getItem(KEY);
    return v ? { "x-condense-signup-intent": v } : {};
  } catch {
    return {};
  }
}

// Per-attempt state: drop it on logout so the next signup doesn't inherit a
// prior attempt's intent (a stale "org" would route a single signup to the
// org waitlist, since the header rides every /v1/me request).
export function clearSignupIntent(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* sessionStorage blocked — nothing to clear */
  }
}
